 <template>
  <form class="newComm" @submit="create()" onsubmit="return false">
    <div class="row grid-12">
      <div class="title grid-8" v-if="!comm">Novo comunicado</div>
      <div
        v-if="!comm"
        class="closeNewComm grid-4 justify-end"
        @click="$parent.openComm=false"
        title="Fechar"
      >
        <i class="fa fa-times" title="Fechar"></i>
      </div>
    </div>

    <div class="form row column-s wrap">
      <div class="column grid-6 grid-12-s">
        Nome
        <input v-model="form.nome" type="text" class="input" placeholder="Nome" required />
        Título
        <input
          v-model="form.titulo"
          type="text"
          class="input"
          placeholder="Titulo"
          required
        />
        Usuários
        <select v-model="form.tipo_usuario" class="input">
          <option value="cliente">Clientes</option>
          <option value="doutor">Supporters</option>
          <option value="funcionario">Funcionários</option>
        </select>
        Em destaque?
        <select v-model="form.destaque" class="input">
          <option :value="false">Não</option>
          <option :value="true">Sim</option>
        </select>
        Validade
        <input
          v-model="form.validade"
          type="date"
          class="input"
          placeholder="Validade"
          required
        />
      </div>

      <div class="grid-6 grid-12-s column">
        <Files
          :showDrop="showDrop"
          @changeDrop="(v) => showDrop = v"
          @file="(f) => file = f"
          :templateRender="form.template || ''"
        />
      </div>
    </div>

    <div class="divider"></div>
    <div class="row">
      <div class="grid-6">
        <Button
          type="button"
          class="createNewComm back"
          layout="white-m-gray"
          v-if="comm"
          @click="router.push('/funcionario/comunicados')"
        >
          <i class="fa fa-arrow-left"></i> COMUNICADOS
        </Button>
      </div>
      <div class="grid-6 row justify-end">
        <Button class="createNewComm" layout="green-go" :loader="loader" v-if="!comm">CRIAR</Button>
        <div v-else>
          <Button
            class="updateComm createNewComm"
            layout="green-go"
            :loader="loader"
            v-if="!comm.publicado"
          >ATUALIZAR</Button>
          <Button
            v-if="!comm.publicado"
            class="publish"
            type="button"
            layout="green-s"
            @click="publish()"
            :loader="loader"
          >PUBLICAR</Button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Router from "@/router";
import Files from "@/components/FileTemplate.vue";

export default {
  name: "Comm",
  components: { Button, Files },
  props: { comm: Object },
  data() {
    return {
      loader: false,
      router: Router,
      file: new FormData(),
      showDrop: false,
      form: {
        nome: "",
        titulo: "",
        validade: false,
        tipo_usuario: "cliente",
        destaque: false
      }
    };
  },
  beforeMount() {
    if (this.comm) {
      this.form = this.comm;
      this.showDrop = true;
    }
  },
  methods: {
    ...mapActions("admin", [
      "CREATE_COMM",
      "UPDATE_COMM",
      "PUBLISH_COMM",
      "CREATE_TEMPLATE",
      "UPDATE_TEMPLATE"
    ]),
    create() {
      this.loader = true;
      event.preventDefault();

      if (!this.comm) {
        this.CREATE_TEMPLATE(this.file).then(r => {
          if (r && r.status == 201) {
            this.form.id_arquivo = r.data.id;
            this.CREATE_COMM(this.form).then(r2 => {
              this.loader = false;
              if (r2 && (r2.status == 200 || r2.status == 201)) {
                this.form.id = r2.data.id;
                this.$parent.communications.unshift(this.form);
                this.form = {
                  nome: "",
                  titulo: "",
                  validade: false,
                  tipo_usuario: "cliente",
                  destaque: false
                };
                this.file = new FormData();
                this.showDrop = false;
              }
            });
          } else {
            this.loader = false;
          }
        });
      } else {
        delete this.form.alterado_em;
        delete this.form.alterado_por;
        delete this.form.criado_em;
        delete this.form.criado_por;
        delete this.form.template;

        this.UPDATE_COMM(this.form).then(r => {
          if (r.status == 200) {
            this.file.set("id", this.form.id);
            this.UPDATE_TEMPLATE(this.file);
          }
        });
        this.loader = false;
      }
    },
    publish() {
      this.loader = true;
      this.PUBLISH_COMM(this.comm.id).then(r => {
        this.loader = false;
        if (r.status == 200 || r.status == 201) this.comm.publicado = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.newComm {
  color: $gray-6;
  background: $white;
  margin-top: 1rem;
  border-radius: 23px;
  padding: 25px;
  box-shadow: $shadow;

  font-size: 15px;
  font-weight: 300;
  .input {
    width: 94%;
    margin-bottom: 20px;
    margin-top: 5px;
  }
  select {
    width: 98.1% !important;
  }
  .title {
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  &.close {
    height: 0px;
    overflow: hidden;
    opacity: 0;
  }
  &.open {
    margin-top: 20px;
    margin-bottom: 3rem;
    @media (min-width: $small) {
      height: 565px;
    }
  }
  .back {
    font-size: 13px;
    font-weight: bold;
    padding: 7px;
  }

  .divider {
    margin-top: 25px;
  }
  .createNewComm {
    margin-top: 20px;
  }
  .publish {
    height: 32px;
    margin-left: 18px;
  }
  .closeNewComm {
    text-align: right;
    margin-top: -12px;
    cursor: pointer;
    font-size: 35px;
    &:hover {
      color: $red-1;
    }
  }
}
</style>